export default {
	items: [
		{
			name: "Home",
			url: "/home",
			icon: "cui-home",
			variant: "test",
		},
		// {
		// 	name: "Main",
		// 	url: "/base",
		// 	icon: "icon-menu",
		// 	children:[
		{
			name: "Jobs",
			url: "/base/jobs",
			icon: "cui-layers"
		},
		// {
		// 	name: "Applicants",
		// 	url: "/base/requisitions",
		// 	icon: "icon-book-open"
		// },
		{
			name: "Candidates",
			url: "/base/resumes",
			icon: "ci ci-copy",
			// badge: {
			// 	variant: "warning",
			// 	text: "BETA"
			// }
		}
		,
		{
			name: "Calendar",
			url: "/communication/calendar",
			icon: "icon-calendar"
		},
		
		// {
		// 	name: "Settings",
		// 	url: "/settings/Branding",
		// 	icon: "ci ci-settings"
		// },
		{
			name: "Help",
			url: "https://talentscript.zendesk.com/hc/en-us",
			icon: "ci ci-help",
			attributes: { target: "_blank", rel: "noreferrer noopener", active: false, hidden: false },
		},
		// {
		// 	name: "Visit TalentScript",
		// 	url: "http://talentscript.com",
		// 	variant: "success",
		// 	icon: "icon-direction",
		// 	class: "mt-auto"
		// }
	]
};
